<div class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="programName" (closeEvent)="close()" [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()"></child-header>
    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
    <loading-screen *ngIf="!finishLoading"></loading-screen>
    <div #ParentWrapper class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="page-title-wrapper">
          <div class="row">
            <div class="col-md-10 page-title-description">
              <p>{{ longDescription }}</p>&nbsp;
            </div>
            <div class="col-md-2 small-logo">
              <img [src]="logoURL"
                   [class.adjust-logo-size]="programType === 'CISCO' || programType === 'CISCOSAAS'">
            </div>
          </div>
        </div>
        <div class="top-divider"></div>
      </div>
      <div class="inner-subBlock-wrapper"  *ngIf="loadContent">
        <div class="searchInputGroup push-left">
          <div class="searchIcon">
            <img src="../../images/new_ui/filter.png">
          </div>
          <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                 onblur="this.placeholder='Filter'" [(ngModel)]="searchField" (ngModelChange)="onChange()">
        </div>
        <ng-container *ngIf="!hasEmptyFilterResult">
          <div class="mTable-header"></div>
          <div class="mTable" *ngIf="annuities?.length">
            <table matSort (matSortChange)="sortData($event)" class="white">
              <thead>
              <tr class="row">
                <th class="col-1"></th>
                <!-- <th class="col-2" mat-sort-header="endUserName" style="padding-left: 15px !important;">
                    ENROLMENT NO
                </th> -->
                <!-- <th class="col" mat-sort-header="programType" [hidden]="pageView=='PROGRAMS'">PROGRAM TYPE</th>
<th class="col" mat-sort-header="nextOrderNo" [hidden]="pageView=='PROGRAMS'">ORDER NO</th> -->
                <th mat-sort-header="currCustomerRef" class="col-3">CUSTOMER REF
                </th>
                <th mat-sort-header="billingDate" class="align-left col-3">LAST
                  INVOICE</th>
                <th mat-sort-header="totalAmount" class="align-right col-3">
                  LAST AMOUNT (Ex) </th>
                <!-- <th mat-sort-header="status" class="align-right col" style="max-width: 14%;">STATUS</th> -->
                <th class="col" style="max-width: 9%;">
                </th>
              </tr>
              </thead>
              <tbody>
              <ng-container>
                <ng-container
                  *ngFor="let annuity of sortedData | TableFilterMultiple:['endUserName', 'currCustomerRef', 'billingDate', 'totalAmount', 'status'] : searchField"
                  #enduserTable>
                  <tr class="row">
                    <td class="col-1 align-right"> <span class="small-logo-wrapper"
                                                         *ngIf="annuity?.hasPaymentSetup">
                                                    <img src="../images/new_ui/my-account/digital-wallet.png">
                                                </span></td>
                    <!-- <td class="manage-text col-2" style="padding-left: 15px !important;">
                        {{annuity?.vendorAgreementNo}}</td> -->
                    <!-- <td class="manage-text col-md" [hidden]="pageView=='PROGRAMS'">{{annuity?.programType}}</td>
<td class="manage-text col-md" [hidden]="pageView=='PROGRAMS'">{{annuity?.nextOrderNo}}</td> -->
                    <td class="col-3">
                      {{annuity?.currCustomerRef}}
                    </td>
                    <td class="align-left col-3">
                      {{annuity?.lastBillingDate}}</td>
                    <!-- <td class="align-center col" [class.annuityprice]="!annuity?.priceLoadingStatus" style="max-width: 12%"> -->
                    <td class="align-right col-3" style=" padding-right: 35px !important;">
                      {{annuity?.lastBillingAmount | currency:'AUD':'symbol-narrow':'.2-2'}}
                    </td>
                    <!-- <td class="align-left col" style="max-width: 14%">{{annuity?.status}}</td> -->
                    <td class="col text-right">
                      <button class="button button-red button-mid"
                              (click)="manageRedirect(annuity, model.detailsView)">Manage</button>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              </tbody>
            </table>
          </div>
        </ng-container>
        <ng-container *ngIf="hasEmptyFilterResult">
          <div class="noResult-wrapper">
            <div><img src="../images/new_ui/no-found.png"></div>
            <div>No results found</div>
            <div>Sorry, that filter combination has no results.<br>Please try different criteria.</div>
            <div>
              <button (click)="filterReset()" class="button button-red button-large">Try again</button>
            </div>
            <div class="noResult-feedback">Send Feedback</div>
          </div>
        </ng-container>
      </div>

    </div>
  </div>
  <div class="blockContainer narrow-sidebar narrow-sidebar-overflow" id="levelTwo" *ngIf="narrowMode">
    <div class="combination-loader">
      <div class="child-sidebar">
        <child-header [title]="programName" (closeEvent)="close()" [showDownload]="showDownload" titleDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()" ></child-header>
        <div class="child-body child-body-narrowMode">
          <div class="searchInputGroup">
            <div class="searchIcon search-carts">
              <img src="../images/new_ui/filter.png">
            </div>
            <input class="searchInput searchInputGroup-small" type="text" placeholder="Filter"
                   onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField"
                   (ngModelChange)="onChange()">
            <!-- <div *ngIf="showDownload" class="basic-icon download-icon download-icon-narrowMode" placement="bottom" ngbTooltip="Download Excel" (click)="exportExcelForAnnuities()">
        </div> -->
          </div>
          <!-- <div class="menu-wrapper">
          <img style="width:100%" [src]="logoURL">
          </div> -->
          <ng-container *ngFor="let item of sortedData | TableFilter: 'endUserName' : searchField">
            <div class="menu-wrapper menu-wrapper-position" [class.active]="isActive(item?.annuityId)"
                 (click)="manageRedirect(item, model.detailsView)">
              <div class="total-div">
                <div class="narrow-title">{{item?.endUserName}}</div>
                <span class="narrow-text">{{item?.status}} |
                                    Amount:
                  {{item?.totalAmount | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
              </div>
              <div class="icon">
                <!-- <img src="../images/new_ui/subscription-add.png"> -->
                <span class="basic-icon information-icon information-icon-position"></span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="child-loader">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
